import { TimeRangeConfig } from '@/api/generated/model';

export type DeepLinkTargetType = 'interaction' | 'conversation';
export type DeepLinkResolvedState = {
  interactionId: string | null;
  conversationId: string | null;
};

type ResolveDeepLinkStateInput = {
  urlInteractionId: string | null;
  urlConversationId: string | null;
  storedInteractionId: string | null;
  storedConversationId: string | null;
};

export function getDeepLinkIdOnlyTooltipText(type: DeepLinkTargetType) {
  return `Viewing shared ${type}. Loaded by ${type} ID only, other filters and search are ignored`;
}

export function getDeepLinkScopedStorageKeys(scope: string) {
  const keyPrefix = 'nebuly.deepLink';
  return {
    interactionKey: `${keyPrefix}:${scope}:interactionId`,
    conversationKey: `${keyPrefix}:${scope}:conversationId`,
  };
}

export function resolveDeepLinkState(input: ResolveDeepLinkStateInput): DeepLinkResolvedState {
  // URL params always win over persisted storage.
  // If both URL params are present, interaction takes precedence.
  if (input.urlInteractionId) {
    return { interactionId: input.urlInteractionId, conversationId: null };
  }
  if (input.urlConversationId) {
    return { interactionId: null, conversationId: input.urlConversationId };
  }

  const interactionId = input.storedInteractionId ?? null;
  const conversationId = interactionId ? null : (input.storedConversationId ?? null);
  return { interactionId, conversationId };
}

export function getDeepLinkExpandedTimeRange(
  defaultRange: TimeRangeConfig,
  isDeepLinkActive: boolean,
): TimeRangeConfig {
  if (!isDeepLinkActive) return defaultRange;
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    kind: 'custom' as TimeRangeConfig['kind'],
    start: '2000-01-01 00:00:00+00:00',
    end: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} 23:59:59+00:00`,
  };
}
